import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LeftMenu from "../LeftMenu";
import General from "./ui/General";
import Education from "./ui/Education";
import Experience from "./ui/Experience";
import Insurance from "./ui/Insurance";
import Conditions from "./ui/Conditions";
import Military from "./ui/Military";
import Family from "./ui/Family";
import Qualification from "./ui/Qualification";
import Certifications from "./ui/Certifications";
import Preporation from "./ui/Preporation";
import Accreditation from "./ui/Accreditation";
import Attestations from './ui/Attestations';
import FormationDocuments from "./ui/FormationDocuments";
import PsychiatricExamination from "./ui/PsychiatricExamination";
import SickLeave from "./ui/SickLeave";
import InformationSocial from "./ui/InformationSocial";
import AdditionalPayment from "./ui/AdditionalPayment";
import Penalties from "./ui/Penalties";
import DrugsAdmission from './ui/DrugsAdmission';
import AppointmentsMovements from "./ui/AppointmentsMovements";
import Incentives from "./ui/Incentives";
import TitlesAwards from "./ui/TitlesAwards";
import Layoff from "./ui/Layoff";
import BusinessTrips from "./ui/BusinessTrips";
import Vacations from "./ui/Vacations";
import WorkExperience from "./ui/WorkExperience";
import EmploymentOreder from "./ui/EmploymentOrder";

const mockMenuItems: {
  [key: string]: JSX.Element;
} = {
  GeneralInformation: <General/>,
  Education: <Education/>,
  Experience: <Experience/>,
  HealthInsurance: <Insurance/>, 
  LivingConditions: <Conditions/>,
  MilitaryRegistration: <Military/>,
  FamilyComposition: <Family/>,
  Training: <Qualification/>,
  Certification: <Certifications/>,
  PreparatoryTraining: <Preporation/>,
  Accreditation: <Accreditation/>,
  Attestations: <Attestations/>,
  FormationDocuments: <FormationDocuments/>,
  PsychiatricExamination: <PsychiatricExamination/>,
  SickLeave: <SickLeave/>,
  InformationSocial: <InformationSocial/>,
  AdditionalPayment: <AdditionalPayment/>,
  Penalties: <Penalties/>,
  AccessToDrugs: <DrugsAdmission/>,
  AppointmentsMovements: <AppointmentsMovements/>,
  Incentives: <Incentives/>,
  TitlesAwards: <TitlesAwards/>,
  Layoff: <Layoff/>,
  BusinessTrips: <BusinessTrips/>,
  Vacations: <Vacations/>,
  WorkExperience: <WorkExperience/>,
  EmploymentOreder: <EmploymentOreder/>,
};

const SelectedEmployee: FC<{
  handleMenuItem: (menuItem: string) => void;
  selectedEmployees: {
    Id: string;
    Name: string;
    Surname: string;
    Patronymic: string;
    EmploymentDate: string;
    Section: string;
    WorkPosition: string;
    DismissDate: string;
    WorkType: string;
  }[];
  tab: number;
  menuItem: string;
}> = ({ handleMenuItem, selectedEmployees, tab, menuItem }) => (
  <Box display="flex">
    <LeftMenu handleMenuItem={handleMenuItem} />
    <Box
      display="flex"
      flexDirection="column"
      marginX="8px"
      overflow="auto"
    >
      <Box display="flex" marginBottom="16px">
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.Surname}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.Name}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.Patronymic}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.WorkPosition}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.WorkType}
        </Typography>
      </Box>
      <Box display="flex" overflow="auto">
        {mockMenuItems[menuItem]}
      </Box>
    </Box>
  </Box>
);

export default SelectedEmployee;
